import axios from "../../apiFc24";

export const trackTacticUsage = async (tacticId: string): Promise<void> => {
  await axios.post(`/tactics/${tacticId}/track`);
};
